import React, {
  useEffect,
  useState,
} from 'react';

import axios from 'axios';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';

import {
  Route,
  Routes,
} from 'react-router-dom';

import Missing
  from './components/switchedContent/Missing';

import HomesList
  from './features/homes/HomesList';

import HomesMainList
  from './features/homes/HomesMainList';

import HomesPilar1List
  from './features/homes/HomesPilar1List';

import HomesPilar2List
  from './features/homes/HomesPilar2List';

import HomesPilar3List
  from './features/homes/HomesPilar3List';

import HomesAnnouncesList
  from './features/homes/HomesAnnouncesList';

import AddFormHome
  from './features/homes/AddFormHome';

import EditFormHome
  from './features/homes/EditFormHome';

import ResultsFrameworkPage
  from './features/resultsFramework/ResultsFrameworkPage';

import PostsList
  from './features/posts/PostsList';

import AddFormPost
  from './features/posts/AddFormPost';

import SinglePostPage
  from './features/posts/SinglePostPage';

import EditFormPost
  from './features/posts/EditFormPost';

import UsersList
  from './features/users/UsersList';

import UserPage
  from './features/users/UserPage';

import Participants
  from './features/users/Participants';

import Partners
  from './features/users/Partners';

import Layout
  from './components/Layout';

/* ADMIN */

import OpportunityReviewPage
  from './features/opportunities/OpportunityReviewPage';

import AdminLayout
  from './features/admin/AdminLayout';

import AdminDashboard
  from './features/admin/AdminDashboard';

import AdminLoginPage
  from './features/admin/AdminLoginPage';

import OpportunityEditorPage
  from './features/admin/OpportunityEditorPage';

import OpportunitySourcesPage
  from './features/admin/OpportunitySourcesPage';

import OpportunitySourceEditorPage
  from './features/admin/OpportunitySourceEditorPage';

import ResultsFrameworkAdminPage
  from './features/admin/ResultsFrameworkAdminPage';

import ResultFrameworkEditorPage
  from './features/admin/ResultFrameworkEditorPage';

import ProgrammeContentAdminPage
  from './features/admin/ProgrammeContentAdminPage';

import ProgrammeContentEditorPage
  from './features/admin/ProgrammeContentEditorPage';

import PartnershipEnquiriesPage
  from './features/admin/PartnershipEnquiriesPage';

import PartnershipEnquiryDetailPage
  from './features/admin/PartnershipEnquiryDetailPage';

import RequireAdmin
  from './features/admin/RequireAdmin';


axios.defaults.withCredentials = true;


function App() {
  const [
    adminUser,
    setAdminUser,
  ] = useState(null);

  const [
    adminAuthChecked,
    setAdminAuthChecked,
  ] = useState(false);


  useEffect(() => {
    const checkAdminSession =
      async () => {
        try {
          const response =
            await axios.get(
              `${process.env.REACT_APP_API_BASE_URL}/api/v1/admin/session`
            );

          const csrfResponse =
            await axios.get(
              `${process.env.REACT_APP_API_BASE_URL}/api/v1/admin/csrf`
            );

          const token =
            csrfResponse.data.csrf_token;

          axios.defaults.headers.post[
            'X-CSRF-Token'
          ] = token;

          axios.defaults.headers.put[
            'X-CSRF-Token'
          ] = token;

          axios.defaults.headers.patch[
            'X-CSRF-Token'
          ] = token;

          axios.defaults.headers.delete[
            'X-CSRF-Token'
          ] = token;

          setAdminUser(
            response.data.user
          );
        } catch (error) {
          setAdminUser(null);

          delete axios.defaults.headers.post[
            'X-CSRF-Token'
          ];

          delete axios.defaults.headers.put[
            'X-CSRF-Token'
          ];

          delete axios.defaults.headers.patch[
            'X-CSRF-Token'
          ];

          delete axios.defaults.headers.delete[
            'X-CSRF-Token'
          ];
        } finally {
          setAdminAuthChecked(true);
        }
      };

    checkAdminSession();
  }, []);


  return (
    <div className="App">
      <Routes>

        {/* PUBLIC WEBSITE */}

        <Route
          path="/"
          element={<Layout />}
        >
          <Route
            index
            element={<HomesList />}
          />

          <Route path="/homes">
            <Route
              index
              element={
                <HomesMainList />
              }
            />

            <Route
              path="main"
              element={
                <HomesMainList />
              }
            />

            <Route
              path="pilar1"
              element={
                <HomesPilar1List />
              }
            />

            <Route
              path="pilar2"
              element={
                <HomesPilar2List />
              }
            />

            <Route
              path="pilar3"
              element={
                <HomesPilar3List />
              }
            />

            <Route
              path="announces"
              element={
                <HomesAnnouncesList />
              }
            />

            <Route
              path="add/:homeId"
              element={
                <AddFormHome />
              }
            />

            <Route
              path="edit/:homeId"
              element={
                <EditFormHome />
              }
            />
          </Route>

          <Route path="/posts">
            <Route
              index
              element={
                <PostsList />
              }
            />

            <Route
              path="add/:postId"
              element={
                <AddFormPost />
              }
            />

            <Route
              path=":postId"
              element={
                <SinglePostPage />
              }
            />

            <Route
              path="edit/:postId"
              element={
                <EditFormPost />
              }
            />
          </Route>

          <Route path="/users">
            <Route
              index
              element={
                <UsersList />
              }
            />

            <Route
              path=":userId"
              element={
                <UserPage />
              }
            />

            <Route
              path="participants"
              element={
                <Participants />
              }
            />

            <Route
              path="sponsors"
              element={
                <Partners />
              }
            />
          </Route>

          <Route
            path="/opportunities/review"
            element={
              <OpportunityReviewPage />
            }
          />

          <Route
            path="/results-framework"
            element={
              <ResultsFrameworkPage />
            }
          />

          <Route
            path="/results-framework/pillar/:pilarId"
            element={
              <ResultsFrameworkPage />
            }
          />

          <Route
            path="*"
            element={
              <Missing />
            }
          />
        </Route>


        {/* ADMIN LOGIN */}

        <Route
          path="/admin/login"
          element={
            <AdminLoginPage
              adminUser={
                adminUser
              }
              setAdminUser={
                setAdminUser
              }
            />
          }
        />


        {/* ADMIN WORKSPACE */}

        <Route
          path="/admin"
          element={
            <RequireAdmin
              adminUser={
                adminUser
              }
              adminAuthChecked={
                adminAuthChecked
              }
            >
              <AdminLayout
                adminUser={
                  adminUser
                }
                setAdminUser={
                  setAdminUser
                }
              />
            </RequireAdmin>
          }
        >
          <Route
            index
            element={
              <AdminDashboard />
            }
          />

          <Route
            path="opportunities"
            element={
              <OpportunityReviewPage />
            }
          />

          <Route
            path="opportunities/new"
            element={
              <OpportunityEditorPage />
            }
          />

          <Route
            path="opportunities/:id/edit"
            element={
              <OpportunityEditorPage />
            }
          />

          <Route
            path="opportunity-sources"
            element={
              <OpportunitySourcesPage />
            }
          />

          <Route
            path="opportunity-sources/new"
            element={
              <OpportunitySourceEditorPage />
            }
          />

          <Route
            path="opportunity-sources/:id/edit"
            element={
              <OpportunitySourceEditorPage />
            }
          />

          <Route
            path="results-framework"
            element={
              <ResultsFrameworkAdminPage />
            }
          />

          <Route
            path="results-framework/:id/edit"
            element={
              <ResultFrameworkEditorPage />
            }
          />

          <Route
            path="programme-content"
            element={
              <ProgrammeContentAdminPage />
            }
          />

          <Route
            path="programme-content/:id/edit"
            element={
              <ProgrammeContentEditorPage />
            }
          />

          <Route
            path="partnership-enquiries"
            element={
              <PartnershipEnquiriesPage />
            }
          />

          <Route
            path="partnership-enquiries/:id"
            element={
              <PartnershipEnquiryDetailPage />
            }
          />
        </Route>

      </Routes>
    </div>
  );
}

export default App;
